if (!customElements.get('custom-accordion')) {
  class CustomAccordion extends HTMLElement {
    constructor() {
      super();

      this.accordion = new Accordion.default(this);
      this.mql = window.matchMedia('(min-width: 990px)');

      this.update();
      window.addEventListener('resize', this.update.bind(this));
    }

    update() {
      if (this.mql.matches) {
        // console.log('CustomAccordion.destroy');
        this.accordion.destroyAll();
      } else {
        // console.log('CustomAccordion.init');
        this.accordion.init();
      }
    }
  }

  customElements.define('custom-accordion', CustomAccordion);
}
